import React, {useEffect, useState} from 'react';
import {Box, Button, Card, CardContent, CardHeader, Container, Divider, makeStyles} from "@material-ui/core";
import Page from "../../components/Page";
import LineChart from "../../components/LineChart";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}));

const Dashboard = () => {
    const classes = useStyles();
    const [moneyLogs, setMoneyLogs] = useState([]);
    const [usersMap, setUsersMap] = useState(new Map());

    const fillData = () => {
        axios.get('smartPiggy').then(sp => {
            setMoneyLogs(sp.data.moneyLogs)
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        axios.get('smartPiggy/getSmartPiggyUsers').then(users => {
            const mp = new Map();
            users.data.forEach(u => {
                mp[u._id] = u;
            });

            setUsersMap(mp);
        }).catch(err => {
            console.log(err)
        })
        fillData();
    }, [])

    return (
        <Page
            className={classes.root}
            title="Dashboard"
        >
            <Container maxWidth="lg">
                <Box mt={3}>
                    <Card>
                        <CardHeader
                            title="Dashboard"
                        />
                        <Divider/>
                        <CardContent>
                            <LineChart moneyLogs={moneyLogs} usersMap={usersMap}/>

                        </CardContent>
                        <Divider/>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button color="primary" variant="contained" onClick={fillData}> Refresh Chart </Button>
                        </Box>
                    </Card>
                </Box>
            </Container>
        </Page>
    );
}

export default Dashboard;